export default __webpack_public_path__ + "static/11-87bfb97568ce5efd00a242cf988f2b9a.jpg";